import { useEffect, useState } from "react"
import _get from "lodash/get"
import _size from "lodash/size"
import _map from "lodash/map"
import _orderBy from "lodash/orderBy"

import { getTrafficSummary } from "services/state/actions"

export const useOptionsByTrafficSummary = (id) => (dispatch, getState) => {
  const [currentOption, setCurrentOption] = useState(null)
  const { traffic } = getState()
  const balanceDetails = _orderBy(
    _get(traffic, "traffic.balanceDetails", []),
    (detail) => Number(detail.balanceAmount),
    ["desc"]
  )

  const options = _map(balanceDetails, (detail) => ({
    label: detail.balanceType,
    value: detail.balanceType
  }))

  useEffect(() => {
    if (_size(traffic.traffic)) {
      setCurrentOption(options[0])
      return
    }

    getTrafficSummary({ contractId: id })(dispatch)
  }, [])

  return [options, currentOption || options[0], setCurrentOption]
}



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/utils/useOptionsByTrafficSummary.js